import { cn } from "@onclicks/sharedcomponents/ui";
import { cva, VariantProps } from "class-variance-authority";
import { ButtonHTMLAttributes } from "react";
import Icon from "./icon";

const buttonVariants = cva(
  "flex items-center justify-center gap-2 transition-all box-border",
  {
    variants: {
      variant: {
        primary:
          "bg-primary text-white hover:bg-primary/90 shadow-md shadow-black/20",
        secondary:
          "border border-slate-300 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 dark:text-white shadow-md shadow-black/20",
        danger:
          "border border-red-500/30 text-red-500 hover:bg-red-500 hover:text-white transition-all duration-200 active:scale-95 font-bold disabled:border-gray-700 disabled:text-gray-700",
      },
      size: {
        small: "px-2 py-2 text-sm rounded-lg",
        default: "px-4 py-2 text-sm rounded-lg",
        full: "w-full py-4 text-base rounded-xl",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  } as const,
);

interface ButtonProps
  extends
    ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  icon?: string;
  /** Action en cours : affiche un spinner et bloque les clics. */
  loading?: boolean;
}

const Button = ({
  icon,
  loading = false,
  disabled,
  variant,
  size,
  type = "button",
  className,
  children,
  ...props
}: ButtonProps) => (
  <button
    type={type}
    className={cn(
      buttonVariants({ variant, size }),
      loading && "cursor-wait opacity-70",
      className,
    )}
    disabled={disabled || loading}
    aria-busy={loading || undefined}
    {...props}
  >
    {loading ? (
      <Icon name="progress_activity" className="text-lg animate-spin" />
    ) : (
      icon && <Icon name={icon} className="text-lg" />
    )}
    {children}
  </button>
);

export default Button;
